<template>
  <div :class="$style.root">
    <h1 :class="$style.title">
      Настройки
    </h1>
    
    <div :class="$style.section">
      <h2 :class="$style.sectionTitle">
        Смена пароля
      </h2>
      
      <form :class="$style.form" @submit.prevent="handleChangePassword">
        <form-item
          :class="$style.formItem"
          :error="errors.currentPassword"
        >
          <text-input
            v-model="form.currentPassword"
            type="password"
            placeholder="Текущий пароль"
            :disabled="loading"
          />
        </form-item>
        
        <form-item
          :class="$style.formItem"
          :error="errors.newPassword"
        >
          <text-input
            v-model="form.newPassword"
            type="password"
            placeholder="Новый пароль"
            :disabled="loading"
          />
        </form-item>
        
        <form-item
          :class="$style.formItem"
          :error="errors.confirmPassword"
        >
          <text-input
            v-model="form.confirmPassword"
            type="password"
            placeholder="Подтвердите новый пароль"
            :disabled="loading"
          />
        </form-item>
        
        <div :class="$style.actions">
          <btn
            type="submit"
            :loading="loading"
            :disabled="!isFormValid"
          >
            Изменить пароль
          </btn>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AUTH_USER } from '@/store/getters';
import FormItem from '@/ui-kit/FormItem';
import TextInput from '@/ui-kit/TextInput';
import Btn from '@/ui-kit/Btn';
import { changePassword } from '@/api/user';

export default {
  name: 'Settings',
  components: {
    FormItem,
    TextInput,
    Btn,
  },
  data() {
    return {
      loading: false,
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      errors: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      user: AUTH_USER,
    }),
    isFormValid() {
      return this.form.currentPassword && 
             this.form.newPassword && 
             this.form.confirmPassword &&
             this.form.newPassword === this.form.confirmPassword;
    },
  },
  methods: {
    async handleChangePassword() {
      if (!this.isFormValid) return;
      
      this.loading = true;
      this.clearErrors();
      
      try {
        await changePassword({
          userId: this.user.id,
          current_password: this.form.currentPassword,
          new_password: this.form.newPassword,
          confirm_password: this.form.confirmPassword,
        });
        
        this.$toast.success('Пароль успешно изменен');
        this.resetForm();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    
    handleError(error) {
      if (error.response?.data) {
        const data = error.response.data;
        this.errors = {
          currentPassword: data.current_password?.[0] || '',
          newPassword: data.new_password?.[0] || '',
          confirmPassword: data.confirm_password?.[0] || '',
        };
      } else {
        this.$toast.error('Произошла ошибка при смене пароля');
      }
    },
    
    clearErrors() {
      this.errors = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
    },
    
    resetForm() {
      this.form = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
    },
  },
};
</script>

<style lang="scss" module>
@import "~@/ui-kit/_theme/main.scss";

.root {
  padding: $gap-xl;
}

.title {
  font-size: $font-size-header-primary;
  font-weight: $font-weight-bold;
  color: $text-primary-color;
  margin: 0 0 $gap-xl 0;
}

.section {
  margin-bottom: $gap-xl;
}

.sectionTitle {
  font-size: $font-size-header-secondary;
  font-weight: $font-weight-bolder;
  color: $text-primary-color;
  margin: 0 0 $gap-l 0;
}

.form {
  max-width: 400px;
}

.formItem {
  margin-bottom: $gap-m;
}

.actions {
  margin-top: $gap-l;
}
</style>
